import birthdayreminder from "../../images/projects/birthdayreminder.png";
import tours from "../../images/projects/tours.png";
import reviews from "../../images/projects/reviews.png";
import faq from "../../images/projects/faq.jpg";
import menu from "../../images/projects/menu.png";
import portfolio from "../../images/projects/portfolio.png";
import reviewsslider from "../../images/projects/reviewsslider.png";
import loremgenerator from "../../images/projects/loremgenerator.png";
import colorgenerator from "../../images/projects/colorgenerator.png";
import grocerylist from "../../images/projects/grocerylist.png";
import navbar from "../../images/projects/navbar.jpg";
import sidebar from "../../images/projects/sidemenu.png";
import submenu from "../../images/projects/submenu.png";
import cart from "../../images/projects/cart.png";
import cocktails from "../../images/projects/cocktails.png";

export const ProjectItems = [
  {
    title: "Birthday Reminder",
    url: "/birthday-reminder",
    image: birthdayreminder,
    cName: "projects__container__links__link",
  },
  {
    title: "Tours",
    url: "/tours",
    image: tours,
    cName: "projects__container__links__link",
  },
  {
    title: "Reviews",
    url: "/reviews",
    image: reviews,
    cName: "projects__container__links__link",
  },
  {
    title: "FAQ Accordion",
    url: "/faq",
    image: faq,
    cName: "projects__container__links__link",
  },
  {
    title: "Menu",
    url: "/menu",
    image: menu,
    cName: "projects__container__links__link",
  },
  {
    title: "Portfolio Tabs",
    url: "/portfolio-tabs",
    image: portfolio,
    cName: "projects__container__links__link",
  },
  {
    title: "Reviews Slider",
    url: "/reviews-slider",
    image: reviewsslider,
    cName: "projects__container__links__link",
  },
  {
    title: "Paragraph Generator",
    url: "/lorem-generator",
    image: loremgenerator,
    cName: "projects__container__links__link",
  },
  {
    title: "Color Generator",
    url: "/color-generator",
    image: colorgenerator,
    cName: "projects__container__links__link",
  },
  {
    title: "Grocery List",
    url: "/grocery-list",
    image: grocerylist,
    cName: "projects__container__links__link",
  },
  {
    title: "Navbar",
    url: "/navbar",
    image: navbar,
    cName: "projects__container__links__link",
  },
  {
    title: "Sidebar + Modal",
    url: "/sidebar-modal",
    image: sidebar,
    cName: "projects__container__links__link",
  },
  {
    title: "Stripe Submenu",
    url: "/stripe-app",
    image: submenu,
    cName: "projects__container__links__link",
  },
  {
    title: "Cart",
    url: "/cart",
    image: cart,
    cName: "projects__container__links__link",
  },
  {
    title: "Cocktails",
    url: "/cocktails-app",
    image: cocktails,
    cName: "projects__container__links__link",
  },
];
